import { storefrontCartServicesHttpClient } from '../../utils/HttpClient'

export const getOrCreateCheckout = async (cartId: string) => {
  try {
    const { data } = await storefrontCartServicesHttpClient.put(`/carts/${cartId}/get-or-create-checkout`, {})

    return data
  } catch (e) {
    console.error('Failed while fetching getOrCreateCheckout(), API - `/carts/${cartId}/get-or-create-checkout`', e)
    throw new Error(`getOrCreateCheckout Failed for cartId: ${cartId}`)
  }
}
